import { defineMessages } from 'react-intl';

export const evidenceSettingsPopoverMessages = defineMessages({
  suggestionsHeading: {
    defaultMessage: 'Suggestions',
    id: '2wHPAZvI/3',
    description: 'Title for the floating Ask Heidi evidence suggestions settings popover',
  },
  browseAll: {
    defaultMessage: 'Browse all',
    id: '1j5Yit+AkK',
    description: 'Opens the full shortcut and protocol marketplace from settings',
  },
  editShortcutsAria: {
    defaultMessage: 'Edit shortcuts',
    id: 'Ucr3p7X2Co',
    description: 'Accessibility label for entering edit mode for pinned shortcuts',
  },
  doneEditingAria: {
    defaultMessage: 'Done editing',
    id: 'IPb7w1hRkp',
    description: 'Accessibility label for leaving edit mode for pinned shortcuts',
  },
  closeAria: {
    defaultMessage: 'Close',
    id: 'iY0kdLi6DW',
    description: 'Accessibility label for closing the evidence settings popover',
  },
  pinnedSectionHeading: {
    defaultMessage:
      '{sectionMode, select, edit {My Shortcuts} view {Saved} other {Saved}}',
    id: '+sAjXRJvlV',
    description: 'Section heading above pinned shortcut chips in edit vs view mode',
  },
  clinicalSectionHeading: {
    defaultMessage:
      '{sectionMode, select, edit {Suggested} view {Clinical Considerations} other {Clinical Considerations}}',
    id: '3G3j+KsX3r',
    description: 'Section heading above clinical category chips in edit vs normal mode',
  },
  emptyTitle: {
    defaultMessage: 'No suggestions enabled',
    id: 'QEBkxFjXmo',
    description:
      'Empty state title when clinical suggestions are off and there are no pins',
  },
  emptySubtitle: {
    defaultMessage: 'Enable clinical suggestions to see recommendations',
    id: 'QlVzR+6qWq',
    description: 'Empty state helper text under no-suggestions title',
  },
});
